import useMediaQueries from "hooks/useMediaQueries.js";
import React, { useEffect, useRef, useState } from "react";
import "./IncreaseDecreaseBox.scss";

const IncreaseDecreaseBox = ({ value, setValue, minValue, maxValue }) => {
  const [disableDecreaseButton, setDisableDecreaseButton] = useState(
    minValue >= value
  );
  const [disalbeIncraseButton, setDisableIncreaseButton] = useState(
    maxValue <= value
  );

  useEffect(() => {
    setDisableDecreaseButton(minValue >= value);
    setDisableIncreaseButton(maxValue <= value);
  }, [value]);

  const { mobileCondition } = useMediaQueries();

  const increaseNumber = () => {
    if (disalbeIncraseButton) {
      return;
    }

    setValue(parseInt(value) + 1);
  };

  const decreaseNumber = () => {
    if (disableDecreaseButton) {
      return;
    }

    setValue(value === 0 ? value : parseInt(value) - 1);
  };

  const handleChange = (e) => {
    // Set zero on backspace
    const value = e.target.value || "0";

    // Value without zeros at the start
    const tempValue = value !== "0" ? value.replace(/^0+/, "") : value;

    //only integers without dots or commas
    const regex = /^[0-9\b]+$/;
    if (regex.test(tempValue)) {
      if (!isNaN(tempValue) && tempValue > maxValue) {
        setValue(maxValue);
      } else if (!isNaN(tempValue) && tempValue < minValue) {
        setValue(minValue);
      } else {
        setValue(tempValue || minValue);
      }
    } else {
      setValue(value);
    }
  };

  const handleBlur = () => {
    if (!isNaN(value) && value > maxValue) {
      setValue(maxValue);
    } else if (!isNaN(value) && value < minValue) {
      setValue(minValue);
    } else {
      setValue(value || minValue);
    }
  };

  return (
    <div className="increase-decrease-container">
      <div
        className={
          !disableDecreaseButton
            ? "decrease-number"
            : "decrease-number decrease-number-disabled"
        }
        onClick={decreaseNumber}
      >
        -
      </div>
      <input
        type="number"
        name="value"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <div
        className={
          !disalbeIncraseButton
            ? "increase-number"
            : "increase-number increase-number-disabled"
        }
        onClick={increaseNumber}
      >
        +
      </div>
    </div>
  );
};

export default IncreaseDecreaseBox;
